import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { FirestoreService } from 'src/app/services/firestore.service';
import { UtilService } from 'src/app/services/util.service';
import Swal from "sweetalert2";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-modal-popups',
  templateUrl: './modal-popups.component.html',
  styleUrls: ['./modal-popups.component.scss'],
})
export class ModalPopupsComponent implements OnInit {
  lastMaintenance: any;
  @ViewChild('vm', { static: false }) vm: ElementRef<HTMLElement>;
  @ViewChild('check', { static: false }) check: ElementRef<HTMLElement>;
  @ViewChild('pm', { static: false }) pm: ElementRef<HTMLElement>;
  headerList = [
    { columnName: 'Activities', columnId: 'activityName' },
    { columnName: 'Frequency', columnId: 'frequency' },
    { columnName: 'Last Maintenance', columnId: 'maintenanceDate' },
    { columnName: 'Next Maintenance', columnId: 'nextMaintenance' },
  ];
  checklist: any;
  equipmentList: any = [];
  pathArray: any[] = [];
  equipmentPath: any = '';
  @Input() screen: string;
  predictiveList: any[];
  activeField: any = {};
  @Input('values')
  set in(val: any) {
    if (val.type == 'equipment') {
      this.lastMaintenance = val.data;
      this.getEquipments();
      setTimeout(() => {
        let el: HTMLElement = this.vm.nativeElement;
        el.click();
      }, 10);
    } else if (val.type == 'checklist') {
      this.checklist = val.data;
      setTimeout(() => {
        let el: HTMLElement = this.check.nativeElement;
        el.click();
      }, 10);
    } else if (val.type == 'predictive') {
      this.predictiveList = val.data;
      this.predictiveList.forEach((c, index) => {
        this.activeField[index] = true;
      });
      setTimeout(() => {
        let el: HTMLElement = this.pm.nativeElement;
        el.click();
      }, 10);
    }
  }
  getEquipments() {
    let params = {
      category: 'EQUIPMENTS',
      conditions: [
        {
          key: 'assetcode',
          symbol: '==',
          value: this.lastMaintenance.assetcode,
        },
        {
          key: 'agency',
          symbol: '==',
          value: this.lastMaintenance.agency,
        },
      ],
    };
    this.fs.getData(params).subscribe((data: any) => {
      if (data.status == 'success') {
        this.equipmentList = data.data;
        this.pathArray.unshift(this.lastMaintenance.equipmentName);
        if (this.lastMaintenance.parentId != this.lastMaintenance.assetcode) {
          this.findParentPath(this.lastMaintenance.parentId);
        } else {
          this.makePathString();
        }
      }
    });
  }
  findParentPath(parentId) {
    let parent = this.equipmentList.filter((e) => {
      return parentId == e.equipmentId;
    });
    this.pathArray.unshift(parent[0].equipmentName);
    if (parent[0].parentId == parent[0].assetcode) {
      this.makePathString();
    } else {
      this.findParentPath(parent[0].parentId);
    }
  }
  makePathString() {
    this.pathArray.forEach((s, index) => {
      let seperator = index != this.pathArray.length - 1 ? ' > ' : '';
      this.equipmentPath += `${s}${seperator}`;
    });
  }
  tpeOf(value) {
    return typeof value;
  }
  comments;
  constructor(
    private modalService: NgbModal,
    private fs: FirestoreService,
    private util: UtilService
  ) {}
  ngOnInit(): void {}
  formatDate(date,type?:any) {
    if (date && date != 'null') {
      if (typeof date != 'object') {
        if(Number(date) != NaN){
          date = type && type=='dateTime'?moment(Number(date)).format('DD-MMM-YYYY, hh:mm:ss a')
          :moment(Number(date)).format('DD-MMM-YYYY');
        }else{
          date = type && type=='dateTime'?moment(date).format('DD-MMM-YYYY, hh:mm:ss a') :moment(date).format('DD-MMM-YYYY');
        }
      } else {
        date = type && type=='dateTime'?
        moment(date._seconds * 1000).format('DD-MMM-YYYY, hh:mm:ss a'):moment(date._seconds * 1000).format('DD-MMM-YYYY');
      }
    }
    return date ? date : 'NA';
  }
  open(content) {
    let modalOptions = { size: 'lg' };
    this.modalService.open(content, modalOptions).result.then(
      (result) => {
        //this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  addComents() {
    let collectionName;
    let collectionName2;
    // console.log(this.lastMaintenance);
    if (this.screen && this.screen == 'equipments') {
      collectionName = 'EQUIPMENTS';
      collectionName2 = 'MAINTENANCE';
    } else if (this.screen && this.screen == 'maintenance') {
      collectionName = 'MAINTENANCE';
      collectionName2 = 'EQUIPMENTS';
    }
    if (this.comments && this.comments != '') {
      let id = this.lastMaintenance.id;
      delete this.lastMaintenance.id;
      this.lastMaintenance.comments = this.lastMaintenance.comments
        ? this.lastMaintenance.comments
        : [];
      let obj = {
        comment: this.comments,
        timestamp: moment().toDate(),
        commentsBy: localStorage.getItem('email'),
      };
      this.lastMaintenance.comments.push(obj);
      this.fs
        .fireStoreDocUpdate(collectionName, id, this.lastMaintenance)
        .subscribe((response: any) => {
          if (response.status == 'success') {
            this.saveMaintenance(collectionName2);
          } else {
            this.util.showSnakbarMessage(
              'error',
              'Comments Added Failed.',
              'end',
              'top'
            );
          }
        });
    }
  }
  saveMaintenance(collection) {
    let params = {
      category: collection,
      conditions: [
        {
          key: 'equipmentId',
          symbol: '==',
          value: this.lastMaintenance.equipmentId,
        },
      ],
    };
    if (collection == 'MAINTENANCE') {
      if (typeof this.lastMaintenance.maintenanceDate == 'string') {
        this.lastMaintenance.maintenanceDate = moment(
          this.lastMaintenance.maintenanceDate
        ).toDate();
      } else {
        this.lastMaintenance.maintenanceDate = moment(
          this.lastMaintenance.maintenanceDate._seconds * 1000
        ).toDate();
      }
      params.conditions.push({
        key: 'maintenanceDate',
        symbol: '==',
        value: this.lastMaintenance.maintenanceDate,
      });
    }
    this.fs.getData(params).subscribe((data: any) => {
      if (data.status == 'success' && data.data.length) {
        let lastMaintenance = data.data[0];
        if (this.comments && this.comments != '') {
          let id = lastMaintenance.id;
          delete lastMaintenance.id;
          lastMaintenance.comments = lastMaintenance.comments
            ? lastMaintenance.comments
            : [];
          let obj = {
            comment: this.comments,
            timestamp: moment().toDate(),
            commentsBy: localStorage.getItem('email'),
          };
          lastMaintenance.comments.push(obj);
          this.fs
            .fireStoreDocUpdate(collection, id, lastMaintenance)
            .subscribe((response: any) => {
              if (response.status == 'success') {
                this.util.showSnakbarMessage(
                  'success',
                  'Comments Added successfully..',
                  'end',
                  'top'
                );
                this.comments = '';
              } else {
                this.util.showSnakbarMessage(
                  'error',
                  'Comments Added Failed.',
                  'end',
                  'top'
                );
              }
            });
        }
      }
    });
  }
  toggleFunc(i: any) {
    this.activeField[i] = !this.activeField[i];
    // this.activeField = i == this.activeField ? null : i
  }

  predictiveMaintenanceDelete(data:any,index:number) {

    Swal.fire({
      title: 'Do you want to delete the maintenance record?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: `Delete`,
      denyButtonText: `Cancel`,
    }).then((result) => {
      if (result.isConfirmed) {
        data.maintenanceHistory.splice(index, 1);
        this.fs.fireStoreDocUpdate("PREVENTIVE_MAINTENANCE", data.id,{maintenanceHistory:data.maintenanceHistory}).subscribe((response:any)=>{
          if(response.status == "success"){
            this.util.showSnakbarMessage("success", "Maintenance Record Deleted Successfully!", "end", "top");
          } else {
            this.util.showSnakbarMessage("error", response.message, "end", "top");
          }
        }, (err) => {
          console.error(err);
          this.util.showSnakbarMessage("error", "Maintenance Record Deletion failed", "end", "top");
        });
      } else if (result.isDenied) {
      }
    })
  }

  exportChecklistToExcel() {
    if (!this.checklist) return;

    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet('Checklist');

    // Title Block
    worksheet.mergeCells('A1:D1');
    const titleCell = worksheet.getCell('A1');
    titleCell.value = `Checklist [${this.checklist.checklist_name || 'N/A'}]`;
    titleCell.font = { name: 'Arial', size: 14, bold: true };
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
    titleCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE6F2FF' }
    };
    worksheet.getRow(1).height = 32;

    worksheet.addRow([]); // Spacer Row

    // Metadata
    const metadata = [
      { k1: 'Asset:', v1: this.checklist.asset || 'N/A', k2: 'Checked By:', v2: this.checklist.email || 'None' },
      { k1: 'Section:', v1: this.checklist.agency || 'N/A', k2: 'Maintenance Date:', v2: this.formatDate(this.checklist.maintenanceDate) },
      { k1: 'Frequency:', v1: this.checklist.frequency || 'N/A', k2: 'Filled Date:', v2: this.formatDate(this.checklist.actualFilledDate, 'dateTime') }
    ];

    metadata.forEach((row, index) => {
      const rowNum = 3 + index;
      worksheet.getCell(`A${rowNum}`).value = row.k1;
      worksheet.getCell(`A${rowNum}`).font = { bold: true };
      worksheet.getCell(`B${rowNum}`).value = row.v1;
      worksheet.getCell(`C${rowNum}`).value = row.k2;
      worksheet.getCell(`C${rowNum}`).font = { bold: true };
      worksheet.getCell(`D${rowNum}`).value = row.v2;
    });

    worksheet.addRow([]); // Spacer Row

    // Dynamic headers
    const headerColNames = this.checklist.headerColumns.map((col: any) => col.columnName);
    const headerRow = worksheet.addRow(headerColNames);
    headerRow.height = 25;
    headerRow.eachCell((cell) => {
      cell.font = { name: 'Arial', size: 11, bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF1F497D' }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Populate rows (nested loop)
    this.checklist.check_points.forEach((point: any) => {
      const currentLastRow = worksheet.lastRow.number + 1;
      const totalCols = this.checklist.headerColumns.length;

      if (point.header) {
        worksheet.mergeCells(currentLastRow, 1, currentLastRow, totalCols);
        const mergedCell = worksheet.getCell(currentLastRow, 1);
        mergedCell.value = point.header;
        mergedCell.font = { name: 'Arial', size: 11, bold: true, color: { argb: 'FF333333' } };
        mergedCell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFF2F2F2' }
        };
        mergedCell.alignment = { vertical: 'middle', horizontal: 'left', indent: 1 };
        
        const row = worksheet.getRow(currentLastRow);
        row.height = 24;
        for (let c = 1; c <= totalCols; c++) {
          row.getCell(c).border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        }
      } else {
        const rowValues = [];
        this.checklist.headerColumns.forEach((col: any) => {
          const val = point[col.columnId];
          let displayVal = '';

          if (val !== undefined && val !== null) {
            if (typeof val === 'object') {
              displayVal = val.equipmentName || val.name || JSON.stringify(val);
            } else {
              displayVal = String(val);
            }
          } else {
            displayVal = '------';
          }
          rowValues.push(displayVal);
        });

        const dataRow = worksheet.addRow(rowValues);
        dataRow.height = 20;
        dataRow.eachCell((cell) => {
          cell.font = { name: 'Arial', size: 10 };
          cell.alignment = { vertical: 'middle', horizontal: 'left' };
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        });
      }
    });

    // Auto-fit Column Widths
    worksheet.columns.forEach((column: any) => {
      let maxLen = 0;
      column.eachCell({ includeEmpty: true }, (cell: any) => {
        if (cell.address.indexOf(':') === -1 && cell.value) {
          const valLen = String(cell.value).length;
          if (valLen > maxLen) maxLen = valLen;
        }
      });
      column.width = Math.max(maxLen + 4, 15);
    });

    // Save
    const fileName = `${this.checklist.checklist_name.replace(/\s+/g, '_')}_Report_${moment(this.checklist.maintenanceDate).format('DD-MMM-YYYY')}.xlsx`;
    workbook.xlsx.writeBuffer().then((buffer: any) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      FileSaver.saveAs(blob, fileName);
    });
  }

}
